import { motion } from "framer-motion";
import { MaskedLine, Reveal } from "@/components/Reveal";

export default function PageHero({ eyebrow, lines, intro, testId }) {
  return (
    <section className="relative bg-ink pt-32 sm:pt-40 pb-16 sm:pb-24 overflow-hidden" data-testid={testId}>
      <div
        aria-hidden="true"
        className="absolute inset-0 opacity-[0.07]"
        style={{
          backgroundImage:
            "radial-gradient(circle at 20% 30%, rgba(212,175,55,0.4) 0, transparent 40%), radial-gradient(circle at 85% 70%, rgba(212,175,55,0.25) 0, transparent 45%)",
        }}
      />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal y={12}>
          <p className="eyebrow">{eyebrow}</p>
        </Reveal>
        <h1 className="mt-6 font-display font-medium text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#F4F2EE] text-balance">
          {lines.map((line, i) => (
            <MaskedLine key={line} delay={0.15 + i * 0.14}>
              {line}
            </MaskedLine>
          ))}
        </h1>
        {intro && (
          <Reveal delay={0.45} className="mt-7 max-w-2xl">
            <p className="text-base md:text-lg leading-relaxed text-[#A1A1AA]">{intro}</p>
          </Reveal>
        )}
        <Reveal delay={0.55}>
          <div className="hairline-gold mt-12 w-40" aria-hidden="true" />
        </Reveal>
      </div>
    </section>
  );
}
